import axios from 'axios';
import * as React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap/lib';
import { ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr'
import { get } from 'lodash';

interface IPaymentWithCardTransactionModalProps {
  show: boolean;
  dispatch: any;
  closeModal: any;

  transactionId: string;
  policyId: string;

  completePayment(policyId: string): any
}

class PaymentWithCardTransactionModal extends React.Component<IPaymentWithCardTransactionModalProps, any> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      window.addEventListener('message', this.handleWindowMessage, { passive: true });
    }
  }

  componentWillUnmount() {
    if (process.env.BROWSER) {
      window.removeEventListener('message', this.handleWindowMessage, { capture: false });
    }
  }

  private handleWindowMessage = (event: MessageEvent) => {
    const { closeModal, completePayment } = this.props;
    const origin = event.origin || get(event, 'originalEvent.origin');

    if (origin !== axios.defaults.baseURL) {
      return;
    }

    const data = event.data;

    if (data.status !== 'complete') {
      toastr.error('Payment Failed');
    } else {
      toastr.success('Payment Successful');
      completePayment(data);
    }

    closeModal();

  }

  private getIframeUrl = () => {
    const { transactionId } = this.props;
    return axios.defaults.baseURL + '/public/transactions/' + transactionId + ':pay';
  }

  public render() {
    const { show, closeModal } = this.props;
    return (
      <BootstrapModal
        show={show}
        onHide={closeModal}
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader closeButton={false}>
          <ModalTitle>Add card details</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <iframe
            src={this.getIframeUrl()}
            style={{ width: '100%', height: '530px', border: '0px solid' }}
          />
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default PaymentWithCardTransactionModal;
